const GlobalStore = {}

let store;


GlobalStore.init = function(pStore){
    store = pStore;
    GlobalStore.modalTransitionName = () => store.state.modalTransitionName;
    GlobalStore.loginInfo = () => store.state.loginInfo;
    GlobalStore.isLogin = () => store.getters.isLogin;
    GlobalStore.isShowConfirm = () => store.state.isShowConfirm;
    GlobalStore.confirmTitle = () => store.state.confirmTitle;
    GlobalStore.confirmOkName = () => store.state.confirmOkName;
    GlobalStore.confirmCancelName = () => store.state.confirmCancelName;
}

GlobalStore.hideConfirm = function() {
    store.commit('hideConfirm')
}

GlobalStore.showConfirm = function(title, okCallBack, okName = '확인', cancelName = '취소', cancelCallBack) {
    store.commit('showConfirm', {title, okCallBack, okName, cancelName, cancelCallBack})
}

GlobalStore.setLoginInfo = function(loginInfo){
    store.commit('setLoginInfo', loginInfo);
}

GlobalStore.setLastModalFixedInIOS = function(top, height){
    store.commit('setLastModalFixedInIOS', top, height);
}

GlobalStore.unsetLastModalFixedInIOS = function(){
    store.commit('unsetLastModalFixedInIOS');
}

GlobalStore.addModal = function(name, data){
    store.commit('addModal', Object.assign({view : name, ...data}));
}

GlobalStore.hideProModal = function() {
    store.commit('hideProModal')
}

GlobalStore.showProgress = function() {
    store.commit('showProgress')
}

GlobalStore.hideProgress = function() {
    store.commit('hideProgress')
}

GlobalStore.showToast = function(str){
    store.commit('showToast', str);
}

GlobalStore.closeLastModalLoop = function(data) {
    store.commit('closeLastModalLoop', {data})
}

GlobalStore.closeSpliceModal = function(data) {
    store.commit('closeSpliceModal', {data})
}

GlobalStore.showAlert = function(str){
    store.commit('showAlert', str);
}

GlobalStore.closeModalAll = function(){
    store.commit('closeModalAll');
}

GlobalStore.okConfirm = function(){
    store.state.confirmOkCallBack();
}

GlobalStore.cancelConfirm = function() {
    if(store.state.confirmCancelCallback) store.state.confirmCancelCallback();
    store.state.confirmCancelCallBack();
}

GlobalStore.hideConfirm = function(){
    if(store.state.confirmCancelCallback) store.state.confirmCancelCallback();
    store.commit('hideConfirm');
}

const closeLastModal = function(isForceClose = false){
    store.commit('closeLastModal', isForceClose);
}

GlobalStore.logout = function(){
    store.commit('logout');
}

GlobalStore.getModalLength = function(){
    return store.state.modals.length;
}

GlobalStore.addPopFlag = function(closeFunction){
    store.commit('addPopFlag', closeFunction);
};

GlobalStore.closeLastPop = function(isExecuteCloseAction){
    store.commit('closeLastPop', isExecuteCloseAction);
}

GlobalStore.closeLastModal = closeLastModal;

window.closeLastModal = closeLastModal;
// window.goLoginPage = closeLastModal;



export default GlobalStore;
